export const CUT_OFF_ALL_PRODUCTS_IN_HOURS = 48;
